import {
  XOA_HOP_DONG,
  XOA_HOP_DONG_SUCCESS,
  XOA_HOP_DONG_FAILURE,
  SHOW_XOA_HOP_DONG,
  CHECK_XOA_HOP_DONG,
  CHECK_XOA_HOP_DONG_SUCCESS,
  CHECK_XOA_HOP_DONG_FAILURE,
} from "actions/XoaHopDong/actionTypes";

const initialState = {
  xoaHopDongLoading: false,
  showModalXoaHD: false,
  isAllowDelete: true,
};

const xoaHopDong = (state, action) => ({
  ...state,
  xoaHopDongLoading: true,
  isAllowDelete: true,
});

const xoaHopDongSuccess = (state, action) => {
  return {
    ...state,
    xoaHopDongLoading: false,
    showModalXoaHD: false,
    isAllowDelete: true,
  };
};

const xoaHopDongFailed = (state, action) => ({
  ...state,
  xoaHopDongLoading: false,
});
const showXoaHopDong = (state, action) => ({
  ...state,
  showModalXoaHD: !state.showModalXoaHD,
});

const kiemTraXoaHopDong = (state, action) => ({
  ...state,
  kiemTraXoaHopDongLoading: true,
});

const kiemTraXoaHopDongSuccess = (state, action) => {
  return {
    ...state,
    kiemTraXoaHopDongLoading: false,
    isAllowDelete: action.payload,
  };
};

const kiemTraXoaHopDongFailed = (state, action) => ({
  ...state,
  kiemTraXoaHopDongLoading: false,
  isAllowDelete: true,
});
const xoaHopDongReducer = (state = initialState, action) => {
  switch (action.type) {
    case XOA_HOP_DONG:
      return xoaHopDong(state, action);
    case XOA_HOP_DONG_SUCCESS:
      return xoaHopDongSuccess(state, action);
    case XOA_HOP_DONG_FAILURE:
      return xoaHopDongFailed(state, action);
    case SHOW_XOA_HOP_DONG:
      return showXoaHopDong(state, action);
    case CHECK_XOA_HOP_DONG:
      return kiemTraXoaHopDong(state, action);
    case CHECK_XOA_HOP_DONG_SUCCESS:
      return kiemTraXoaHopDongSuccess(state, action);
    case CHECK_XOA_HOP_DONG_FAILURE:
      return kiemTraXoaHopDongFailed(state, action);
    default:
      return state;
  }
};

export default xoaHopDongReducer;
